import { render, staticRenderFns } from "./main.zonas.vue?vue&type=template&id=0369d7a3"
import script from "./main.zonas.vue?vue&type=script&lang=js"
export * from "./main.zonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports